
import { Component, Vue, Prop } from 'vue-property-decorator'
import { baseSearch } from '@/api'
@Component({
    name: 'Search'
})
export default class extends Vue {
    @Prop({ default: false }) readonly isScroll!: boolean
    private inputBorder = { 
        '--input-border': this.isScroll? '1px solid #E0E0E0' : '0',
        '--input-shadow': this.isScroll? '0' : '0px 4px 16px 0px rgba(5,60,200,0.08)'
    }
    private keyWord: string = ''
    private editData = {}
    private timeout: any = null
    // 远程搜索
    private async querySearch(queryString: String, cb: Function) {
        clearTimeout(this.timeout)
        if (!queryString) {
            return
        }
        this.timeout = setTimeout(async () => {
            let res = await baseSearch(this.keyWord)
            this.editData = res.data
            cb([res.data])
        }, 500)
    }
    private async getBaseSearch() {
        let res = await baseSearch(this.keyWord)
        this.editData = res.data
    }
    private changeKeywordColor(title: string, type: string) {
        const reg = new RegExp(this.keyWord, 'ig')
        const result = title.replace(reg, `<span class="text-theme">${this.keyWord}</span>`)
        if(type === 'doc') {
            return `<img class="w-20 vertical-top mr-4" src="https://js.dingdandao.com/library/help-center/images/documentIcon.png">${result}`
        }else {
            return `<img class="w-20 vertical-text-top mr-4" src="https://js.dingdandao.com/library/help-center/images/vedioPlay.png">${result}`
        }
    }
    private stopPop(e: any) {
        e.stopPropagation()
    }
    // 文章详情
    private docClick(id: string) {
        location.href = `/helpCenter/${this.$route.params.ntwId}/Question/QuestionDetail?questionId=${id}&keyWord=${this.keyWord}`
    }
    // 视频详情
    private videoClick(id: string) {
        location.href = `/helpCenter/${this.$route.params.ntwId}/Video/VideoDetail?videoId=${id}&keyWord=${this.keyWord}`
    }
    // 搜索结果
    private onSubmit() {
        const routeData = this.$router.resolve({
            query: {keyWord: this.keyWord},
            path:`/${this.$route.params.ntwId}/SearchResult`
          });
        window.open(routeData.href, '_blank');
    }
}

